import SmallNote from '../SmallNote'
import Bold from './Bold'
import ButtonView from './ButtonView'
import ButtonText from './ButtonText'
import MainFormCheckBox from './MainFormCheckBox'
import RegisterFormMarketingCheckBox from './RegisterFormMarketingCheckBox'

export default {
  ButtonView,
  ButtonText,
  RegisterFormMarketingCheckBox,
  SmallNote,
  Bold,
  MainFormCheckBox,
}
